/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {BundlingSettingsComponent} from './bundling-settings.component';
import {SwitchButtonModule} from '../../shared/switch-button/switch-button.module';
import {BundlingSettingsInputsModule} from '../shared/components/bundling-settings-inputs/bundling-settings-inputs.module';
import {BundlesPipesModule} from '../shared/pipes/bundles-pipes.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {
    BundlingSettingsTabsComponentModule
} from '../shared/components/bundling-settings-tabs/bundling-settings-tabs.component.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [
        BundlingSettingsTabsComponentModule,
        LoadingSpinnerModule,
        CommonModule,
        SwitchButtonModule,
        BundlingSettingsInputsModule,
        BundlesPipesModule,
        PipesModule
    ],
    declarations: [BundlingSettingsComponent],
    exports: [BundlingSettingsComponent]
})
export class BundlingSettingsModule {
}
